import React from 'react';
import { Grid2 as Grid, Skeleton } from '@mui/material';

const SkeletonList = () => {
  return (
    <Grid size={12}>
      <Grid
        container
        spacing={2}
      >
        {[...Array(5).keys()].map((_doc, index) => (
          <Grid
            size={12}
            key={'skeleton-list-' + index}
          >
            <Skeleton
              variant={'rounded'}
              animation="wave"
              height={56}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default SkeletonList;
